import React from 'react';
import {
    Button, Select,
} from '@paretogroup/tess';
import { useCampaignFilterInterface } from '../../interface';
import { ValueInputFactory } from './value-input-factory';
import { useStyles, FilterSection, SelectWrapper } from './filter-drawer-operations.styles';
import {
    FILTER_DRAWER_OPERATIONS_TEXTS,
    FILTER_DRAWER_OPERATIONS_TEST_ID,
    FILTER_DRAWER_OPERATIONS_AUTO_TEST_ID,
} from './filter-drawer-operations.constants';

export const FilterDrawerOperations = () => {
    const {
        field,
        fieldOptions,
        isOperatorDisabled,
        operator,
        operatorOptions,
        value,
        isApplyRuleDisabled,
        onClickApply,
        onChangeField,
        onChangeOperator,
    } = useCampaignFilterInterface();

    const classes = useStyles();

    return (
        <FilterSection>
            <SelectWrapper
                data-testid={FILTER_DRAWER_OPERATIONS_TEST_ID.FIELD}
                data-auto-testid={FILTER_DRAWER_OPERATIONS_AUTO_TEST_ID.FIELD}
            >
                <Select
                    label={FILTER_DRAWER_OPERATIONS_TEXTS.FIELD}
                    onChange={onChangeField}
                    value={field}
                    options={fieldOptions}
                />
            </SelectWrapper>
            <SelectWrapper
                data-testid={FILTER_DRAWER_OPERATIONS_TEST_ID.OPERATOR}
                data-auto-testid={FILTER_DRAWER_OPERATIONS_AUTO_TEST_ID.OPERATOR}
            >
                <Select
                    label={FILTER_DRAWER_OPERATIONS_TEXTS.OPERATOR}
                    isDisabled={isOperatorDisabled}
                    onChange={onChangeOperator}
                    value={operator}
                    options={operatorOptions}
                />
            </SelectWrapper>
            <SelectWrapper
                data-testid={FILTER_DRAWER_OPERATIONS_TEST_ID.VALUE}
                data-auto-testid={FILTER_DRAWER_OPERATIONS_AUTO_TEST_ID.VALUE}
            >
                <ValueInputFactory />
            </SelectWrapper>
            <Button
                className={classes.applyButton}
                color="default"
                onClick={() => onClickApply({ field, operator, value })}
                disabled={isApplyRuleDisabled}
                data-testid={FILTER_DRAWER_OPERATIONS_TEST_ID.APPLY}
                data-auto-testid={FILTER_DRAWER_OPERATIONS_AUTO_TEST_ID.APPLY}
            >
                {FILTER_DRAWER_OPERATIONS_TEXTS.APPLY}
            </Button>
        </FilterSection>
    );
};
